import React from 'react';

const CloseIcon = ({ className = '', ...props }) => (
  <svg 
    width="12" 
    height="12" 
    viewBox="0 0 12 12" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M10 0.868652L11.1314 2.00002L7.13065 5.99965L11.1314 10L10 11.1314L5.99965 7.13065L2.00002 11.1314L0.868652 10L4.86865 5.99965L0.868652 2.00002L2.00002 0.868652L5.99965 4.86865L10 0.868652Z" 
      fill="currentColor"
    />
  </svg>
);

export default CloseIcon;
